module.exports = __webpack_public_path__ + "static/media/logo.493cb84e.svg";